<template>
  <span
    :class="'badge badge-address-validation badge-' + variant"
    v-b-tooltip.hover
    :title="valueTxt"
  >
    <i :class="'fa ' + icon"></i> <span class="ml-1" v-if="type == 'lg'">{{ valueTxt }}</span>
  </span>
</template>

<script>
export default {
  name: 'AddressValidationBadge',
  props: {
    type: {
      type: String,
      default: 'sm'
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    valueTxt() {
      let valueToRet = this.value;
      return valueToRet || 'Address not yet validated';
    },
    variant() {
      if (this.value === 'Address validated successfully')
        return 'success';
      else if (this.value === 'Address validation warning')
        return 'warning';
      else if (this.value === 'Address validation failed')
        return 'danger';
      else
        return 'info';
    },
    icon() {
      if (this.value === 'Address validated successfully')
        return 'fa-check-circle';
      else if (this.value === 'Address validation warning')
        return 'fa-exclamation-triangle';
      else if (this.value === 'Address validation failed')
        return 'fa-window-close';
      else
        return 'fa-question-circle';
    }
  }
};
</script>
